exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button.center-block {\n  margin-top: 50px;\n}\n\nh2 {\n  margin-bottom: 50px;\n}\n\n.avatar {\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Jose.Soto/Documents/Websites/SecretSanta/src/app/participants/participants.component.css
// module id = ../../../../../src/app/participants/participants.component.css
// module chunks = main